/**
 * GeChiUI dependencies
 */
import { Component } from '@gechiui/element';

export class __unstableRichTextInputEvent extends Component {
	render() {
		return null;
	}
}
